module.exports = __webpack_public_path__ + "static/img/a014.ed47358.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a014.jpg
// module id = kZit
// module chunks = 0